/* Component Dependencies */
var dateHeaderTemplate = require('templates/dateHeader.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'dateHeader',
  template: {
    'dateHeader': dateHeaderTemplate
  }
});